<script>

export default {

    components: {

    },

    props: {
        fieldToWatch: {
            type: String,
            required: false,
            default: 'status',
        },
        scoped: {
            type: Boolean,
            default: true,
        },
        onSuccess: {
            type: Function,
            default () {
                return () => {};
            }
        },
        onError: {
            type: Function,
            default () {
                return () => {};
            }
        },
        successStatus: {
            type: Array,
            default () {
                return ['COMPLETED'];
            }
        },
        errorStatus: {
            type: Array,
            default () {
                return ['FAILED'];
            }
        },
        nextModelToWatch: {
            type: Array,
            default (){
                return [''];
            },
        },
        fieldNameWhereFindUidResponse: {
            type: String,
            required: false,
            default: 'instance_id',
        },
        activateLog: {
            type: Boolean,
            required: false,
            default: false,
        },
        loadAtStart: {
            type: Boolean,
            required: false,
            default: false,
        },
        url: {
            type: String,
            required: false,
            default: '',
        },
    },

    data (){
        return {
            currentStep: 0,
            isLoading: false,
            endReached: false,
            result: null,
            hasError: false,
            timeoutId: null,

        };
    },

    computed: {
        hasNextStep (){
            return (this.currentStep + 1 ) < this.successStatus.length;
        }
    },

    created (){
        if(this.loadAtStart){
            this.watchRequestStatus(this.url);
        }
    },

    destroyed (){
        this.stopWatching();
    },

    methods: {

        stopWatching (){
            clearTimeout(this.timeoutId);
        },

        watchRequestStatus(url) {

            this.isLoading = true;
            if(this.activateLog) console.debug('Watching url', url);
            let errorStatus = this.errorStatus[this.currentStep];
            let successStatus = this.successStatus[this.currentStep];

            const scopes = (this.scoped)? this.$store.state.api.scopes : {};
            const config = {headers: scopes};
            this.$store.axios.get(url, config).then((response) => {
                if (successStatus.includes(response.data[this.fieldToWatch])) {

                    if(this.activateLog) console.debug('SUCCESS STATUS REACHED');
                    if(this.hasNextStep){
                        let uid = response.data[this.fieldNameWhereFindUidResponse];
                        let modelUrl = this.$store.state.api.meta.listModels[this.nextModelToWatch[this.currentStep]].url;
                        url = `${modelUrl}${uid}/`;
                        if(this.activateLog) console.debug('ENTER SECOND STEP. NEW URL IS', url);
                        this.currentStep++;
                        this.watchRequestStatus(url);
                        return;
                    }
                    if(this.activateLog) console.debug(response);
                    this.isLoading = false;
                    this.onSuccess(response);
                    this.endReached = true;
                    this.result = response.data;
                } else if (errorStatus.includes(response.data[this.fieldToWatch])) {

                    if(this.activateLog) console.debug('ITEM FAILLED', response);
                    this.isLoading = false;
                    this.onError(response);
                    this.endReached = true;
                    this.hasError = true;
                    this.result = response.data;
                } else {
                    if(this.activateLog) {
                        console.debug('STATUS TO WATCH:', response.data[this.fieldToWatch], 'RETRY');
                    }
                    this.timeoutId = setTimeout(() => {
                        this.watchRequestStatus(url);
                    },3000);
                }
            }).catch((e) => {
                console.debug("ERROR");
                console.error(e);
            });
        },

        resetData (){
            this.currentStep = 0;
            this.isLoading = false;
            this.endReached = false;
            this.result = null;
            this.hasError = false;
            this.timeoutId = null;
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/waitingMixin/index.vue